import { NgTemplateOutlet } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  TemplateRef
} from '@angular/core'
import { NzIconModule } from 'ng-zorro-antd/icon'

@Component({
  selector: 'aiomed-half-screen-modal',
  imports: [NgTemplateOutlet, NzIconModule],
  templateUrl: './half-screen-modal.component.html',
  styleUrl: './half-screen-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HalfScreenModalComponent {
  readonly close = output<void>()

  readonly title = input.required<string>()
  readonly description = input<string>(
    'You can keep using the tablet, but please charge it soon.'
  )
  readonly imageSource = input<string>('assets/images/battery-running-low.png')
  readonly width = input<number>(762)
  readonly descriptionTemplate = input<TemplateRef<unknown> | null>(null)
  readonly descriptionWidth = input<number>(500)
  readonly zIndex = input<number>()
  readonly buttonText = input<string>('OK I’ll charge later')
  readonly buttonWidth = input<number>(434)
}
